import * as React from "react";
import { forwardRef } from "react";
const SvgIcPlayerForward = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "icPlayer-forward" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M20.3086 28.5412L21.8086 29.4072L36.999 20.637V18.905L21.8086 10.1348L20.3086 11.0008L20.3086 18.8897L5.14453 10.1348L3.64453 11.0008L3.64453 28.5412L5.14453 29.4072L20.3086 20.6523V28.5412Z", fill: "currentColor" })));
const ForwardRef = forwardRef(SvgIcPlayerForward);
export { ForwardRef as ReactComponent };
